export default {"src":"/_next/static/media/badge-3-red.2210ea67.svg","height":80,"width":80};